/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Min and max replica bounds for autoscaling in a region.
 */
export type Replicas = {
  /**
   * Minimum number of replicas.
   */
  min: number;
  /**
   * Maximum number of replicas.
   */
  max: number;
};

/** @internal */
export const Replicas$inboundSchema: z.ZodType<
  Replicas,
  z.ZodTypeDef,
  unknown
> = z.object({
  min: z.number().int(),
  max: z.number().int(),
});
/** @internal */
export type Replicas$Outbound = {
  min: number;
  max: number;
};

/** @internal */
export const Replicas$outboundSchema: z.ZodType<
  Replicas$Outbound,
  z.ZodTypeDef,
  Replicas
> = z.object({
  min: z.number().int(),
  max: z.number().int(),
});

export function replicasToJSON(replicas: Replicas): string {
  return JSON.stringify(Replicas$outboundSchema.parse(replicas));
}
export function replicasFromJSON(
  jsonString: string,
): SafeParseResult<Replicas, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Replicas$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Replicas' from JSON`,
  );
}
